// Fire-and-forget — never blocks UI, never throws to caller.
export function track(event, properties = {}) {
  fetch("/api/track", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ event, properties }),
  }).catch(() => {}); // swallow network errors silently
}

// Returns a cleanup function — call in useEffect return.
export function trackOnce(event, properties = {}) {
  let fired = false;
  return () => {
    if (fired) return;
    fired = true;
    track(event, properties);
  };
}
